<ng-container [formGroup]="form">
  <nz-form-item>
    <div class="form-desc">
      Select the specific type of
      {{ categoryName }}. While you may select multiple behaviors, only do so if
      you are confident they are all &nbsp;
      <button
        nz-button
        type="button"
        nzType="text"
        class="primary-text-btn link-btn"
        (click)="openFunctionalEquivalent.emit()">
        Functionally Equivalent.
      </button>
      <span *ngIf="isRequired" class="error-text">*</span>
    </div>
    <div class="checkbox-wrapper">
      <span
        *ngFor="let subCat of behaviourSubCategoryList; trackBy: trackById"
        nz-checkbox
        [nzChecked]="
          form.get('caseBehaviorTypeIds')?.value?.includes(subCat.id)
        "
        (nzCheckedChange)="
          onCheckboxChange('caseBehaviorTypeIds', $event, subCat.id);
          onBehaviorTypeChange($event, subCat)
        "
        [nzValue]="subCat.id">
        {{ subCat.name }}
      </span>
    </div>
    <div
      class="ant-form-item-explain-error mt-3"
      *ngIf="form.get('caseBehaviorTypeIds')?.hasError('required')">
      Please select at least 1 behavior type.
    </div>
  </nz-form-item>
  <ng-container formArrayName="caseBehaviorTypeDescriptions">
    <nz-divider *ngIf="behaviorTypeDescriptionControls.length > 0" />
    <ng-container
      *ngFor="
        let ctrl of behaviorTypeDescriptionControls;
        let i = index;
        trackBy: trackByIndex
      "
      [formGroup]="ctrl">
      <nz-form-item>
        <nz-form-label
          [nzFor]="'behavior-type-description-' + i"
          [nzRequired]="true">
          {{ getBehaviorTypeDescriptionTitle(ctrl.value.behaviorTypeId) }}
        </nz-form-label>
        <nz-form-control>
          <textarea
            [id]="'behavior-type-description-' + i"
            name="description"
            [attr.aria-label]="
              getBehaviorTypeDescriptionTitle(ctrl.value.behaviorTypeId)
            "
            formControlName="description"
            rows="4"
            nz-input
            placeholder="Enter description"
            (input)="
              onControlInputChange($event, ctrl.get('description'))
            "></textarea>
          <div class="mt-3 remaining-text">
            {{ ctrl.value.description.length }} of 4000 characters used
          </div>
          <div
            class="ant-form-item-explain-error mt-3"
            *ngIf="ctrl.get('description')?.errors?.['required']">
            Please enter your description.
          </div>
        </nz-form-control>
      </nz-form-item>
    </ng-container>
  </ng-container>
</ng-container>
